export class FindGroupOrganisationProjectRoleAction {
  public static readonly type =
    '[Authorisation] FindGroupOrganisationProjectRoleAction';
  constructor(
    public readonly userId: string,
    public readonly groupId: string,
  ) {}
}
